import { PortalError } from "@/types/portal-error";
import { Service } from "../mainService";
import { UF } from "@/types/administracao/uf";
import { Municipio } from "@/types/administracao/municipio";

const municipioService = {
  getMunicipios,
  getUFs,
};

async function getUFs(): Promise<UF[]> {
  const response = await Service.$http.get(
    `${process.env.VUE_APP_API_USUARIOS}municipio/ufs`
  );
  if (response.status === 200) return response.data.map((r) => new UF(r));
  console.error("Erro ao buscar unidades federativas", response);
  throw new PortalError("Erro ao buscar unidades federativas");
}

async function getMunicipios(idUF: number): Promise<Municipio[]> {
  const response = await Service.$http.get(
    `${process.env.VUE_APP_API_USUARIOS}municipio/${idUF}/municipios`
  );
  if (response.status === 200)
    return response.data.map((r) => new Municipio(r));
  console.error("Erro ao buscar municípios da uf " + idUF, response);
  throw new PortalError("Erro ao buscar municípios");
}

export default municipioService;
